import BusinessPage from './BusinessPage.jsx';
import BusinessPageWithSlug from './BusinessPageWithSlug.jsx';
import RegisterBusiness from './RegisterBusiness.jsx';
import DaNangBusinessPage from './DaNangBusinessPage.jsx';

export {
  BusinessPage,
  RegisterBusiness,
  BusinessPageWithSlug,
  DaNangBusinessPage
};



// WEBPACK FOOTER //
// ./pages/businesses/index.js